/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import InsuranceClaimsInsuranceClaimAddressAttributes from './InsuranceClaimsInsuranceClaimAddressAttributes';

/**
 * The PractitionersidPractitionerRenderingNpiAttributes model module.
 * @module model/PractitionersidPractitionerRenderingNpiAttributes
 * @version v0.3
 */
export default class PractitionersidPractitionerRenderingNpiAttributes {
  /**
   * Constructs a new <code>PractitionersidPractitionerRenderingNpiAttributes</code>.
   * @alias module:model/PractitionersidPractitionerRenderingNpiAttributes
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PractitionersidPractitionerRenderingNpiAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PractitionersidPractitionerRenderingNpiAttributes} obj Optional instance to populate.
   * @return {module:model/PractitionersidPractitionerRenderingNpiAttributes} The populated <code>PractitionersidPractitionerRenderingNpiAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PractitionersidPractitionerRenderingNpiAttributes();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('number'))
        obj._number = ApiClient.convertToType(data['number'], 'String');
      if (data.hasOwnProperty('addresses_attributes'))
        obj.addressesAttributes = ApiClient.convertToType(data['addresses_attributes'], [InsuranceClaimsInsuranceClaimAddressAttributes]);
    }
    return obj;
  }
}

/**
 * The id of the practitioner's npi you wouldl like to update
 * @member {String} id
 */
PractitionersidPractitionerRenderingNpiAttributes.prototype.id = undefined;

/**
 * The practitioner's NPI used to bill for services rendered by this practitioner 
 * @member {String} _number
 */
PractitionersidPractitionerRenderingNpiAttributes.prototype._number = undefined;

/**
 * @member {Array.<module:model/InsuranceClaimsInsuranceClaimAddressAttributes>} addressesAttributes
 */
PractitionersidPractitionerRenderingNpiAttributes.prototype.addressesAttributes = undefined;

